
const monthShortNames = ["Jan", "Feb", "Mar", "Apr",
    "May", "Jun", "Jul", "Aug",
    "Sep", "Oct", "Nov", "Dec"];

export const FormatDateShortMonth = (date) => {


    const d = new Date(date);
    const day = d.getDate();
    const monthIndex = d.getMonth();
    const monthName = monthShortNames[monthIndex];

    const year = d.getFullYear();

    return `${day} ${monthName} ${year}`;
}

export const FormatDateYYYYMDD = (inputDate) => {
    // Create a new Date object from the input date string
    const date = new Date(inputDate);
  
    // Get the year, month, and day from the Date object
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are zero-based in JavaScript
    const day = date.getDate();
  
    // Format the date in the desired format
    const formattedDate = `${year}/${month}/${day}`;
  
    return formattedDate;
  }

export const addDays = function(date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}

export const minusDays = function(date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() - days);
    return d;
}